<template>
    <div>
        <div id="printContent" class="print-zone">
            <div class="print-title">现货订单</div>
            <div class="order-detail">
                <div>单号：{{ searchData.Osn }}</div>
                <div>
                    开单日期：
                    {{ searchData.CreateTime }}
                </div>
            </div>
            <div class="print-table-main">
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">收货人</div>
                    <div class="div-table-cell" style="width: 30%">
                        {{ searchData.Consignee }}
                    </div>
                    <div class="div-table-cell" style="width: 20%">联系方式</div>
                    <div class="div-table-cell" style="width: 30%">
                        {{ searchData.Mobile }}
                    </div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 20%">客户地址</div>
                    <div class="div-table-cell" style="width: 80%">
                        {{ searchData.Address }}
                    </div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 10%">序号</div>
                    <div class="div-table-cell" style="width: 30%">汽配编码</div>
                    <div class="div-table-cell" style="width: 30%">配件名称</div>
                    <div class="div-table-cell" style="width: 10%">数量</div>
                    <div class="div-table-cell" style="width: 20%">销售价</div>
                </div>
                <div class="div-table-row" v-bind:key="index" v-for="(AP, index) in searchData.GoodsList">
                    <div class="div-table-cell" style="width: 10%">
                        {{ Number(index) + 1 }}
                    </div>
                    <div class="div-table-cell" style="width: 30%">
                        {{ AP.GoodCode }}
                    </div>
                    <div class="div-table-cell" style="width: 30%">
                        {{ AP.GoodsName }}
                    </div>
                    <div class="div-table-cell" style="width: 10%">
                        {{ AP.Count }}
                    </div>
                    <div class="div-table-cell" style="width: 20%">{{ AP.Price }}</div>
                </div>
                <div class="div-table-row">
                    <div class="div-table-cell" style="width: 10%"></div>
                    <div class="div-table-cell" style="width: 30%"></div>

                    <div class="div-table-cell" style="width: 60%; text-align: right">
                        <div style="padding: 0 90px 0 0">
                            总数量: {{ totalCount }} &nbsp;&nbsp;&nbsp;&nbsp;总价:
                            {{ searchData.GoodAmount }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-detail">
                <div>支付方式：{{ searchData.PaymentMethod }}</div>
                <div>发货方式：{{ searchData.ShipFriendName }}</div>
                <div>运费：{{ searchData.ShipFee }}</div>
            </div>
            <!-- <div class="order-remark">
          <div>客户要求：{{item.Remark}}</div>
        </div> -->
            <!--    脚注    -->
            <div class="order-remark" v-if="config == null ? false : config.Result && !isEditConfig">
                {{ config.RValue }}
            </div>
            <div class="order-setcontent" v-if="isEditConfig">
                <el-input type="textarea" resize="auto" rows="3" v-model="config.RValue"></el-input>
            </div>
        </div>

        <div class="dialog-footer">
            <div class="btn-ctn-left">
                <!--   脚注   -->
                <div class="re-set">
                    <el-button class="btn-primary" @click="setConfig()" v-if="config == null ? false : config.Result && !isEditConfig">编辑脚注</el-button>
                    <el-button class="btn-primary" @click="submitConfig()" v-if="isEditConfig">保存脚注</el-button>
                </div>
                <!--   开单时间   -->
                <div class="open-time">
                    <el-button class="btn-primary" @click="setOpenTime()" v-if="openTimeConfig && openTimeConfig.Result && !isEditOpenTime">设置开单时间</el-button>
                    <el-button class="btn-primary" @click="submitOpenTime()" v-if="isEditOpenTime">保存开单时间</el-button>
                </div>
            </div>
            <div class="re-submit">
                <el-button class="btn-primary" v-print="'#printContent'">打印</el-button>
                <el-button @click="cancel()">关闭</el-button>
            </div>
        </div>
    </div>
</template>
<script>
// import html2canvas from "html2canvas";
export default {
    name: '',
    components: {},
    props: ['orderDetails'],
    watch: {
        searchData: function (obj) {
            if (obj.GoodsList) {
                this.totalCount = 0;
                obj.GoodsList.forEach(element => {
                    this.totalCount += element.Count;
                });
            }
        }
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            totalCount: 0,
            searchData: {},
            printList: [],
            company: userMsg.EntpName,
            openTimeConfig: null, // 开单时间配置
            isEditOpenTime: false, // 编辑开单时间
            config: null, // 脚注配置
            isEditConfig: false, // 编辑脚注
            entpId: userMsg.EntpId
        };
    },
    mounted() {
        this.searchData = this.orderDetails;
    },
    methods: {
        // 取消
        cancel() {
            this.$emit('closeDialog');
        },
        // 获取开单时间配置
        getOpenTimeConfig() {
            this.$util.getSysConfig('dyxssj').then(data => {
                this.openTimeConfig = data;
            });
        },
        setOpenTime() {
            this.isEditOpenTime = true;
        },
        submitOpenTime() {
            this.isEditOpenTime = false;
        },
        // 获取脚注权限
        getConfigData() {
            this.$util.getSysConfig('dyxs').then(res => {
                this.config = res.Result;
            });
        },
        setConfig() {
            this.isEditConfig = true;
        },
        // 提交脚注
        submitConfig() {
            this.isEditConfig = false;
            this.$util
                .axiosPost({
                    url: '/api/EntpInfoManagement/UpdateSysConfigResultsById',
                    data: {
                        EntpId: this.entpId,
                        ConfigId: this.config.Id,
                        RValue: this.config.RValue
                    }
                })
                .then(() => {})
                .catch(() => {});
        }
    }
};
</script>
<style lang="less" scoped media="print">
.order-detail {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 15px 0;
    color: #000;
}
.order-remark {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-left: 10px;
    margin-right: 10px;
    padding: 0px 0px 15px 0px;
    color: #000;
}
.order-setcontent {
    padding: 0px 0px 15px 0px;
    color: #000;
}
.print-title {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    color: #000;
}
.dialog-footer {
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
}
.re-submit {
    text-align: right;
}

.print-zone {
    width: 210mm;
    margin-left: 2rpx;
}

.print-table-main {
    width: 792px;
    margin-left: 1px;
    .div-table-cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: auto;
        line-height: 30px;
        padding-left: 10px;
        border-top: 1px solid #000;
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
        color: #000;
    }
    .div-table-row {
        border-left: 1px solid #000;
    }
    .pall-count {
        text-align: right;
        padding-right: 10px;
    }
}
.btn-ctn-left {
    display: flex;
}
</style>
